import React, { Component } from 'react';
import { Row, Col, Form, Button, Toast } from 'react-bootstrap';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faTimesCircle, faUser, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import '../UserView/userViewStyle.scss';
import userService from '../UserView/userService';
import moment from 'moment-timezone';
import SubHeader from './../../../../Layout/SubHeader';
import swal from 'sweetalert';
import { onSelectUserViewAction } from '../../../../../stores/actions/userData';
import { connect } from 'react-redux';
import { Config } from '../../../../../shared/config';
import ToggleButton from 'react-toggle-button';

class SftpUserView extends Component {
    constructor(props) {
        super(props);
        let session = localStorage.getItem('FOM_user');
        this.state = {
            userList: [],
            pages: null,
            loading: false,
            showPagination: false,
            showUserList: false,
            showCustomerList: false,
            searchUserText: '',
            searchCustomerText: null,
            showToast: false,
            showError: true,
            validator: {
                name: false,
                version: false,
            },
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
            userId: null,
            fieldUserName: '',
            fieldEmailAddress: '',
            fieldFirstName: '',
            fieldLastName: '',
            fieldCompanyName: '',
            fieldUserRole: 'CUSTOMER',
            fieldUserStatus: 'ACTIVE',
            disableRefreshButton: false,
            showRefreshLoader: false,
            createdDate: '',
            createdBy: '',
            modifiedDate: '',
            modifiedBy: '',
            crmCustomerId: '',
            userdata: session ? JSON.parse(session).userdata.details : null,
            lookerParams: {},
            enableSFTP: false,
        };

        this.setUserWrapperRef = this.setUserWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.tableRowClick = this.tableRowClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.userService = new userService();
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    render() {
        const {
            userList,
            loading,
            crmCustomerId,
            crmDivisionId,
            crmContactId,
            showPagination,
            showUserList,
            searchUserText,
            userId,
            fieldUserName,
            fieldEmailAddress,
            fieldFirstName,
            fieldLastName,
            fieldCompanyName,
            fieldUserRole,
            fieldUserStatus,
            disableRefreshButton,
            showRefreshLoader,
            createdDate,
            createdBy,
            modifiedDate,
            modifiedBy,
            api,
            showToast,
            enableSFTP,
        } = this.state;
        const displayUserList = showUserList ? 'd-block' : 'd-none';
        const displayCreatedInfo = userId ? 'd-block' : 'd-block';
        let showSearch = true;
        if (this.props.match && this.props.match.params.userId) {
            showSearch = false;
        }

        return (
            <div className="dummy">
                <Row>
                    <Col md={12}>
                        <SubHeader customerNameRoute={fieldCompanyName} />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={6}>
                        <Row>
                            {showSearch ? (
                                <Col sm={12}>
                                    <Form.Group className="form-inline pt-2 mb-1 mb-lg-3">
                                        <Form.Label
                                            column
                                            sm={2}
                                            className=" text-left model-field-label justify-content-start text-nowrap"
                                        >
                                            Search
                                        </Form.Label>
                                        <Col sm={10}>
                                            <div className="user-search-wrapper">
                                                <Form.Control
                                                    id="search-text"
                                                    className="rounded"
                                                    type="text"
                                                    size="sm"
                                                    placeholder="Search with First Name, Last Name, Email"
                                                    name="fieldSearchText"
                                                    onChange={this.handleInputChange}
                                                    value={searchUserText || ''}
                                                />
                                                <FontAwesomeIcon icon={faSearch} className="search-icon-box" />

                                                <div
                                                    className={`user-search-box ${displayUserList}`}
                                                    ref={this.setUserWrapperRef}
                                                >
                                                    <ReactTable
                                                        columns={[
                                                            {
                                                                Header: 'User Name',
                                                                accessor: 'userName',
                                                                width: getColumnWidth(
                                                                    userList,
                                                                    'userName',
                                                                    'User Name',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'First Name',
                                                                accessor: 'firstName',
                                                                width: getColumnWidth(
                                                                    userList,
                                                                    'firstName',
                                                                    'First Name',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'Last Name',
                                                                accessor: 'lastName',
                                                                width: getColumnWidth(
                                                                    userList,
                                                                    'lastName',
                                                                    'Last Name',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'Company',
                                                                accessor: 'companyName',
                                                                width: getColumnWidth(
                                                                    userList,
                                                                    'companyName',
                                                                    'Company',
                                                                ),
                                                            },
                                                        ]}
                                                        data={userList}
                                                        loading={loading} // Display the loading overlay when we need it
                                                        noDataText="No Users found"
                                                        minRows={userList.length}
                                                        showPagination={showPagination}
                                                        pageSize={userList.length ? userList.length : 1}
                                                        className="-highlight cursor-pointer w-100"
                                                        getTrProps={(state, rowInfo) => {
                                                            return {
                                                                onClick: () => {
                                                                    this.tableRowClick(rowInfo);
                                                                },
                                                            };
                                                        }}
                                                        style={
                                                            userList.length >= 5
                                                                ? {
                                                                      height: ' calc(100px + 15vh)',
                                                                  }
                                                                : {}
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            ) : null}
                            <Col sm={showSearch ? 12 : 8}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={showSearch ? 2 : 3}
                                        className="justify-content-start model-field-label text-nowrap required"
                                    >
                                        User Name
                                    </Form.Label>
                                    <Col sm={showSearch ? 10 : 9} className={showSearch ? '' : 'pr-0'}>
                                        <Form.Control
                                            id="user-name"
                                            type="text"
                                            className={showSearch ? '' : 'ml-1'}
                                            readOnly={true}
                                            size="sm"
                                            placeholder="User Name"
                                            name="fieldFirstName"
                                            value={fieldUserName || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            {!showSearch ? (
                                <Col sm={4}>
                                    <Button
                                        className="btn-refrseh"
                                        size="md"
                                        disabled={disableRefreshButton ? 'disabled' : null}
                                        onClick={this.refreshDataFromTas}
                                    >
                                        {showRefreshLoader ? (
                                            <div className="spinner-border spinner-border-sm text-white" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        ) : (
                                            <FontAwesomeIcon icon={faSync} />
                                        )}
                                        <span className="ml-3">Refresh from TAS</span>
                                    </Button>
                                </Col>
                            ) : null}
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="pr-0 justify-content-start model-field-label text-nowrap required"
                                    >
                                        Email Address
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="email-address"
                                            className="rounded"
                                            readOnly={true}
                                            type="text"
                                            size="sm"
                                            placeholder="Email"
                                            name="fieldEmailAddress"
                                            value={fieldEmailAddress || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        First Name
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="first-name"
                                            type="text"
                                            readOnly={true}
                                            size="sm"
                                            placeholder="First Name"
                                            name="fieldFirstName"
                                            value={fieldFirstName || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        Last Name
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="last-name"
                                            type="text"
                                            readOnly={true}
                                            size="sm"
                                            placeholder="Last Name"
                                            name="fieldLastName"
                                            value={fieldLastName || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        Company Name
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="company-name"
                                            type="text"
                                            readOnly={true}
                                            size="sm"
                                            placeholder="Company Name"
                                            name="fieldCompanyName"
                                            value={fieldCompanyName || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        Company ID
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="company-id"
                                            type="text"
                                            readOnly={true}
                                            size="sm"
                                            placeholder="Company ID"
                                            name="fieldCompanyId"
                                            value={crmCustomerId || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        CRM Division ID
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="company-crm-division"
                                            type="text"
                                            readOnly={true}
                                            size="sm"
                                            placeholder="CRM Division ID"
                                            name="fieldCrmDivisionId"
                                            value={crmDivisionId || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        CRM Contact ID
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            id="user-crm-contact"
                                            type="text"
                                            readOnly={true}
                                            size="sm"
                                            placeholder="CRM Contact ID"
                                            name="fieldCrmContactId"
                                            value={crmContactId || ''}
                                            autoComplete="none"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={12} md={6}>
                        <Row>
                            <Col sm={12}>
                                <Form.Group className="form-inline" controlId="formHorizontalEmail">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        User Role
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            as="select"
                                            size="sm"
                                            name="fieldUserRole"
                                            onChange={this.handleInputChange}
                                            value={fieldUserRole || ''}
                                        >
                                            <option value="CUSTOMER">CUSTOMER</option>
                                            <option value="CONSULTANT">CONSULTANT</option>
                                            <option value="ADMIN">ADMIN</option>
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline" controlId="formHorizontalEmail">
                                    <Form.Label
                                        column
                                        sm={2}
                                        className="model-field-label justify-content-start text-nowrap required"
                                    >
                                        Status
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control
                                            as="select"
                                            size="sm"
                                            name="fieldUserStatus"
                                            onChange={this.handleInputChange}
                                            value={fieldUserStatus || ''}
                                        >
                                            <option value="ACTIVE">ACTIVE</option>
                                            <option value="INACTIVE">INACTIVE</option>
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="form-inline">
                                    <Form.Label column sm={3} className="model-field-label text-nowrap">
                                        Grant SFTP Access ?
                                    </Form.Label>

                                    <div>
                                        <ToggleButton
                                            value={enableSFTP}
                                            width={'50px'}
                                            inactiveLabel={'NO'}
                                            activeLabel={'YES'}
                                            colors={{
                                                activeThumb: {
                                                    base: 'rgb(247, 247, 247)',
                                                },
                                                inactiveThumb: {
                                                    base: 'rgb(247, 247, 247)',
                                                },
                                                active: {
                                                    base: 'rgb(26, 108, 157, 1)',
                                                    hover: 'rgb(26, 108, 157, 1)',
                                                },
                                                inactive: {
                                                    base: 'rgb(65,66,68)',
                                                    hover: 'rgb(95,96,98)',
                                                },
                                            }}
                                            onToggle={(value) => {
                                                this.toggleSFTP(!value);
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <div className={`created-info mt-4 ${displayCreatedInfo}`}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                    <span className="ml-2">Created Date</span>
                                                </td>
                                                <td>
                                                    {' '}
                                                    {createdDate
                                                        ? moment(createdDate, Config.API_TIMESTAMP_FORMAT).format(
                                                              Config.UI_TIMESTAMP_FORMAT,
                                                          )
                                                        : null}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faUser} />
                                                    <span className="ml-2">Created By</span>
                                                </td>
                                                <td> {createdBy}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                    <span className="ml-2">Modified Date</span>
                                                </td>
                                                <td>
                                                    {' '}
                                                    {modifiedDate
                                                        ? moment(modifiedDate, Config.API_TIMESTAMP_FORMAT).format(
                                                              Config.UI_TIMESTAMP_FORMAT,
                                                          )
                                                        : null}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faUser} />
                                                    <span className="ml-2">Modified By</span>
                                                </td>
                                                <td> {modifiedBy}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} className="button-group mt-3"></Col>
                    <Col sm={12} md={6} className="button-group mt-3">
                        <Row className="flex-wrap">
                            <Col className="col-md-6 col-lg-4 mb-lg-0 mb-2">
                                <Button
                                    id="save-btn"
                                    className="w-100 m-0 btn-save"
                                    size="md"
                                    disabled={crmCustomerId || userId ? null : 'disabled'}
                                    onClick={this.saveUser}
                                >
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                    <span className="ml-3">Save</span>
                                </Button>
                            </Col>
                            <Col className="col-md-6 col-lg-4 mb-lg-0 mb-2">
                                <Button
                                    id="reset-btn"
                                    className="w-100 m-0 btn-reload"
                                    size="md"
                                    onClick={this.resetUser}
                                >
                                    <FontAwesomeIcon icon={faSync} />
                                    <span className="ml-3">Reset</span>
                                </Button>
                            </Col>
                            <Col className="col-md-6 col-lg-4 mb-lg-0 mb-2">
                                <Button
                                    id="cancel-btn"
                                    className="w-100 m-0 btn-close"
                                    size="md"
                                    onClick={this.closeUser}
                                >
                                    <FontAwesomeIcon icon={faTimesCircle} />
                                    <span className="ml-3">Cancel</span>
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className="toast-container">
                    <Col md={12} className="pt-2">
                        <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                            <Toast.Header className={` ${api.response.status !== 'Failure' ? 'success' : 'error'}`}>
                                <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                                <strong className="mr-auto">{api.response.status}</strong>
                            </Toast.Header>
                            <Toast.Body>{api.response.message}</Toast.Body>
                        </Toast>
                    </Col>
                </Row>
            </div>
        );
    }

    /**
     * Component mounting invoking func
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.match.params.userId) {
            const userId = this.props.match.params.userId;
            this.setState({
                showUserList: false,
            });
            this.getUserDetailsByUserId(userId);
        }
    }

    /**
     * Save User Click
     */
    saveUser = () => {
        const {
            location: { customerId },
        } = this.props;
        let {
            fieldUserName,
            crmCustomerId,
            crmDivisionId,
            crmContactId,
            fieldEmailAddress,
            fieldFirstName,
            fieldLastName,
            fieldCompanyName,
            fieldUserRole,
            fieldUserStatus,
            enableSFTP,
        } = this.state;
        // user id is set then update the user
        if (this.state.userId) {
            let params = {
                userId: this.state.userId,
                crmCustomerId: crmCustomerId ? crmCustomerId : null,
                crmDivisionId: crmDivisionId ? crmDivisionId : null,
                crmContactId: crmContactId ? crmContactId : null,
                userName: fieldUserName,
                emailAddress: fieldEmailAddress,
                firstName: fieldFirstName,
                lastName: fieldLastName,
                companyName: fieldCompanyName,
                userRole: fieldUserRole,
                status: fieldUserStatus,
                sftpEnabled: fieldUserStatus  == 'ACTIVE' ? ( enableSFTP === true ? 1 : 0) : 0,
            };
            // api call for update user.
            this.userService.updateUser(params).then((res) => {
                if (res && res.status === 'Success') {
                    this.setState({
                        showError: false,
                        api: {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        },
                    });
                    swal({
                        title: res.status,
                        text: res.message + ', and you will be redirected to home page',
                        icon: 'success',
                        button: 'OK',
                    }).then(() => {
                        this.props.history.push(`/model/admin/customer/${customerId}`);
                    });
                } else {
                    this.setState({
                        showError: false,
                        api: {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        },
                    });
                    this.toggleToast();
                }
            });
        } else {
            let params = {
                userName: fieldUserName,
                emailAddress: fieldEmailAddress,
                firstName: fieldFirstName,
                lastName: fieldLastName,
                companyName: fieldCompanyName,
                userRole: fieldUserRole,
                status: fieldUserStatus,
                crmCustomerId: crmCustomerId,
                crmDivisionId: crmDivisionId,
                crmContactId: crmContactId,
                sftpEnabled: fieldUserStatus  == 'ACTIVE' ? ( enableSFTP === true ? 1 : 0) : 0,
            };
            // api call for save user.
            this.userService.saveUser(params).then((res) => {
                if (res && res.status === 'Success') {
                    this.setState({
                        showError: false,
                        api: {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        },
                    });
                    swal({
                        title: res.status,
                        text: res.message + ', and you will be redirected to home page',
                        icon: 'success',
                        button: 'OK',
                    }).then(() => {
                        this.props.history.push(`/model/admin/customer/${customerId}`);
                    });
                } else {
                    this.setState({
                        showError: false,
                        api: {
                            response: {
                                status: res.status,
                                message: res.message,
                            },
                        },
                    });
                    this.toggleToast();
                }
            });
        }
    };

    /**
     * Refresh Data from TAS
     */
    refreshDataFromTas = () => {
        this.setState({
            disableRefreshButton: true,
            showRefreshLoader: true,
        });
        let params = {
            userName: this.state.fieldUserName,
        };
        // api call for refresh user.
        this.userService.refreshUser(params).then((res) => {
            if (res && res.status === 'Success') {
                setTimeout(() => {
                    this.setState({
                        disableRefreshButton: false,
                        showRefreshLoader: false,
                        crmCustomerId: res.data.crmCustomerId,
                        crmDivisionId: res.data.crmDivisionId,
                        crmContactId: res.data.crmContactId,
                        fieldUserName: res.data.userName,
                        fieldEmailAddress: res.data.emailAddress,
                        fieldFirstName: res.data.firstName,
                        fieldLastName: res.data.lastName,
                        fieldCompanyName: res.data.companyName,
                        api: {
                            response: {
                                status: 'Success',
                                message: 'Refreshed Successfully',
                            },
                        },
                    });
                    this.toggleToast();
                }, 1000);
            } else {
                this.setState({
                    showError: false,
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.toggleToast();
                this.setState({
                    disableRefreshButton: false,
                    showRefreshLoader: false,
                });
            }
        });
    };

    /**
     * Reset form to previous state
     */
    resetUser = () => {
        swal({
            title: 'Are you sure to reload?',
            text: 'You will not be able to recover unsaved user!',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                // fetching already set user data by userId
                if (this.state.userId) {
                    this.getUserDetailsByUserId(this.state.userId);
                    setTimeout(() => {
                        this.setState({
                            showError: false,
                            api: {
                                response: {
                                    status: 'Success',
                                    message: 'Reset Successfully',
                                },
                            },
                        });
                        this.toggleToast();
                    }, 1000);
                } else {
                    this.setState({
                        searchUserText: '',
                        fieldUserName: '',
                        fieldEmailAddress: '',
                        fieldFirstName: '',
                        fieldLastName: '',
                        fieldCompanyName: '',
                        crmCustomerId: '',
                        crmDivisionId: '',
                        crmContactId: '',
                        fieldUserRole: '',
                        fieldUserStatus: '',
                    });
                }
            }
        });
    };


    /**
     * Close user
     */
    closeUser = () => {
        const {
            location: { customerId },
        } = this.props;
        this.props.setSelectedUser(null);
        this.props.history.push(`/model/admin/customer/${customerId}`);
    };

    /**
     * Get user details by userId
     */
    getUserDetailsByUserId(userId) {
        this.userService.getUserDetails(userId).then((res) => {
            if (res.status === 'Success' && res.data) {
                this.setState({
                    userId: res.data.userId,
                    fieldUserName: res.data.userName,
                    fieldEmailAddress: res.data.emailAddress,
                    fieldFirstName: res.data.firstName,
                    fieldLastName: res.data.lastName,
                    fieldCompanyName: res.data.company,
                    fieldUserRole: res.data.userRole,
                    fieldUserStatus: res.data.status,
                    crmCustomerId: res.data.crmCustomerId,
                    crmDivisionId: res.data.crmDivisionId,
                    crmContactId: res.data.crmContactId,
                    createdDate: moment.utc(res.data.createdDate, Config.UI_TIMESTAMP_FORMAT).local(),
                    createdBy: res.data.createdBy,
                    modifiedDate: moment.utc(res.data.modifiedDate, Config.UI_TIMESTAMP_FORMAT).local(),
                    modifiedBy: res.data.modifiedBy,
                    enableSFTP: res.data.sftpEnabled,
                });
            } else {
                this.setState({});
            }
        });
    }

    /**
     * Search Input field change event
     */
    userSearch(value) {
        this.setState({ searchUserText: value, showUserList: true, loading: true }, function () {
            if (this.state.searchUserText != null) {
                this.userService.getUserList(this.state.searchUserText).then((res) => {
                    if (res.status === 'Success' && res.data.length > 0) {
                        this.setState({
                            loading: false,
                            userList: res.data,
                        });
                    } else {
                        this.setState({
                            loading: false,
                            showUserList: true,
                            userList: [],
                        });
                    }
                });
            } else {
                this.setState({
                    loading: false,
                    userList: [],
                });
            }
        });
    }

    /** Invoking when clicking a row from the user search result table
     *
     * @param {object} rowInfo - clicked row data.
     */
    tableRowClick(rowInfo) {
        this.setState({ showUserList: false });
        // checking the row event click in table data is not empty.
        const userSelectedData = rowInfo.original;
        if (userSelectedData) {
            this.setState({
                fieldUserName: userSelectedData.userName,
                fieldEmailAddress: userSelectedData.emailAddress,
                fieldFirstName: userSelectedData.firstName,
                fieldLastName: userSelectedData.lastName,
                fieldCompanyName: userSelectedData.companyName,
                crmCustomerId: userSelectedData.crmCustomerId,
                crmDivisionId: userSelectedData.crmDivisionId,
                crmContactId: userSelectedData.crmContactId,
                fieldUserRole: 'CUSTOMER',
                fieldUserStatus: 'INACTIVE',
            });
        }
    }

    /**
     * Handling input change
     * @param {*} event event
     */
    handleInputChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        if (name === 'fieldSearchText' && !this.props.match.params.userId) this.userSearch(value);
        if (name === 'fieldUserRole') this.setState({ fieldUserRole: value });
        if (name === 'fieldUserStatus') this.setState({ fieldUserSatus: value });
        this.setState({
            [name]: value,
        });
        if (name === 'fieldSearchText') {
            this.setState({
                searchUserText: value,
            });
        }
    }

    /**
     * Invoke if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.userWrapperRef && !this.userWrapperRef.contains(event.target)) {
            this.setState({ showUserList: false });
        }
    }

    /**
     * Invoking on component unmounting
     */
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setUserWrapperRef(node) {
        this.userWrapperRef = node;
    }

    toggleSFTP = (enableSFTP) => {
        this.setState({
            enableSFTP: enableSFTP,
        });
    };
}

SftpUserView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    setSelectedUser: PropTypes.func,
    setSelectedCustomer: PropTypes.func,
    location: PropTypes.object,
};

/**
 * Redux dipatch events method for changing redux state
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setSelectedUser: (params) => dispatch(onSelectUserViewAction(params)),
    };
};

export default withRouter(connect(null, MapDispatchToProps)(SftpUserView));

/**
 * Dynamic column width settings
 */
const getColumnWidth = (rows, accessor, headerText) => {
    const maxWidth = 856;
    const magicSpacing = 10;
    const cellLength = Math.max(...rows.map((row) => (`${row[accessor]}` || '').length), headerText.length);
    return Math.min(maxWidth, cellLength * magicSpacing);
};
